<div class="admin-wrapper">
  <div class="table-title">ADMIN</div>
  <div class="admin-layout-grid">

    <!-- TOP ROW: Development Areas + Facility Types -->
    <div class="admin-top-row">

      <!-- LEFT: Development Areas -->
      <div class="table-wrapper">
        <div class="table-card" [class.expanded]="expandedTable === 'dev'">
          <div class="table-header">
            <h3>Development Areas</h3>
            <div class="button-group">
              <button class="expand-btn" (click)="toggleExpand('dev')">
                {{ expandedTable === "dev" ? "Collapse" : "Open" }}
              </button>
              <button *ngIf="expandedTable === 'dev' && hasAnyFilterApplied('dev')" (click)="clearAllFilters('dev')">
                Clear Filters
              </button>
              <button (click)="handleSave('dev')">Save</button>
              <button (click)="exportAdminTable('dev')" [disabled]="!dataDevArea.length">
                Export
              </button>
              <button (click)="handleDelete('dev')" [disabled]="!selectedRowsDev.length">
                Delete
              </button>
              <button (click)="clearSelection('dev')" *ngIf="selectedRowsDev.length">
                Clear Select
              </button>
            </div>
          </div>

          <div class="table-scroll" [ngClass]="{ 'scroll-expanded': expandedTable === 'dev' }">
            <table>
              <thead>
                <tr>
                  <th style="width: 62px">Select</th>
                  <th *ngFor="let col of columnsDevArea">
                    <div class="col-wrap">
                      <span>{{ col.header }}</span>
                      <div class="filter-icon-container" *ngIf="expandedTable === 'dev' && col.filterable">
                        <img
                          class="filter-icon"
                          [ngClass]="{ 'active-filter': isFilterActive('dev', col.field.toString()) }"
                          [src]="isFilterActive('dev', col.field.toString()) ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                          width="16"
                          height="16"
                          alt="Filter"
                          [title]="isFilterActive('dev', col.field.toString()) ? 'Filter applied - ' + col.header : 'Filter ' + col.header"
                          (click)="openFloatingFilter($event, 'dev', col.field.toString())"
                        />
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of filteredDataDevArea">
                  <td>
                    <input type="checkbox" [checked]="isRowSelected(row, 'dev')"
                      (change)="toggleRowSelection(row, 'dev', $event)" />
                  </td>
                  <td *ngFor="let col of columnsDevArea">
                    <ng-container *ngIf="col.field === 'owner' && col.lookup">
                      <div class="multi-owner-field">
                        <div class="owner-tags">
                          <span *ngFor="let owner of row['owner']" class="owner-chip">
                            {{ owner }}
                            <span class="remove-chip" (click)="removeOwner(row, owner)">×</span>
                          </span>
                          <select class="owner-select" (change)="addOwner(row, $event)"
                            [disabled]="!isEditable('dev', row)">
                            <option value="" disabled selected hidden>
                              Select Owner
                            </option>
                            <option *ngFor="let opt of lookupData['owner']" [value]="opt"
                              [disabled]="row['owner'].includes(opt)">
                              {{ opt }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="col.editable && col.field !== 'owner'">
                      <input type="text" [ngModel]="getCellValue(row, col.field)" (ngModelChange)="
                          setCellValue(row, col.field, $event, 'dev')
                        " [disabled]="!isEditable('dev', row, col.field)" />
                    </ng-container>

                    <ng-container *ngIf="!col.editable && col.field !== 'owner'">
                      <span *ngIf="col.field === 'isActive'; else defaultDevCell" class="status-pill-wrapper">
                        <button type="button" class="status-pill" [ngClass]="getStatusClass(row[col.field])"
                          [disabled]="row.isStatusUpdating" (click)="toggleDevAreaStatus(row)">
                          {{ row.isStatusUpdating ? 'Updating...' : getCellValue(row, col.field) }}
                        </button>
                        <span class="status-tooltip" role="tooltip">
                          {{ getStatusHoverMessage(row) }}
                        </span>
                      </span>
                      <ng-template #defaultDevCell>
                        {{ getCellValue(row, col.field) }}
                      </ng-template>
                    </ng-container>
                  </td>
                </tr>
                <tr *ngIf="!filteredDataDevArea.length">
                  <td [attr.colspan]="columnsDevArea.length + 1" class="empty-filter-state">
                    No development areas match the current filter.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- RIGHT: Facility Types -->
      <div class="table-wrapper">
        <div class="table-card" [class.expanded]="expandedTable === 'type'">
          <div class="table-header">
            <h3>Facility Types</h3>
            <div class="button-group">
              <button class="expand-btn" (click)="toggleExpand('type')">
                {{ expandedTable === "type" ? "Collapse" : "Open" }}
              </button>
              <button *ngIf="expandedTable === 'type' && hasAnyFilterApplied('type')" (click)="clearAllFilters('type')">
                Clear Filters
              </button>
              <button (click)="handleAdd('type')">New</button>
              <button (click)="handleSave('type')">Save</button>
              <button (click)="exportAdminTable('type')" [disabled]="!dataFacilityType.length">
                Export
              </button>
              <button (click)="handleDelete('type')" [disabled]="!selectedRowsType.length">
                Delete
              </button>
              <button (click)="clearSelection('type')" *ngIf="selectedRowsType.length">
                Clear
              </button>
              <button *ngIf="showCancelType" (click)="handleCancel('type')">
                Cancel
              </button>
            </div>
          </div>

          <div class="table-scroll" [ngClass]="{ 'scroll-expanded': expandedTable === 'type' }">
            <table>
              <thead>
                <tr>
                  <th style="width: 62px">Select</th>
                  <th *ngFor="let col of columnsFacilityType">
                    <div class="col-wrap">
                      <span>{{ col.header }}</span>
                      <div class="filter-icon-container" *ngIf="expandedTable === 'type' && col.filterable">
                        <img
                          class="filter-icon"
                          [ngClass]="{ 'active-filter': isFilterActive('type', col.field.toString()) }"
                          [src]="isFilterActive('type', col.field.toString()) ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                          width="16"
                          height="16"
                          alt="Filter"
                          [title]="isFilterActive('type', col.field.toString()) ? 'Filter applied - ' + col.header : 'Filter ' + col.header"
                          (click)="openFloatingFilter($event, 'type', col.field.toString())"
                        />
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of filteredDataFacilityType">
                  <td>
                    <input type="checkbox" [checked]="isRowSelected(row, 'type')"
                      (change)="toggleRowSelection(row, 'type', $event)" />
                  </td>
                  <td *ngFor="let col of columnsFacilityType">
                    <ng-container *ngIf="col.editable">
                      <input type="text" [ngModel]="getCellValue(row, col.field)" (ngModelChange)="
                          setCellValue(row, col.field, $event, 'type')
                        " [disabled]="!isEditable('type', row, col.field)" />
                    </ng-container>
                    <ng-container *ngIf="!col.editable">
                      {{ getCellValue(row, col.field) }}
                    </ng-container>
                  </td>
                </tr>
                <tr *ngIf="!filteredDataFacilityType.length">
                  <td [attr.colspan]="columnsFacilityType.length + 1" class="empty-filter-state">
                    No facility types match the current filter.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>

    <!-- BOTTOM: Facility Names -->
    <div class="table-card table-card-fullwidth" [class.expanded]="expandedTable === 'name'">
      <div class="table-header">
        <h3>Facility Names</h3>
        <div class="button-group">
          <button class="expand-btn" (click)="toggleExpand('name')">
            {{ expandedTable === "name" ? "Collapse" : "Open" }}
          </button>
          <button *ngIf="expandedTable === 'name' && hasAnyFilterApplied('name')" (click)="clearAllFilters('name')">
            Clear Filters
          </button>
          <button (click)="handleSave('name')">Save</button>
          <button (click)="exportAdminTable('name')" [disabled]="!dataFacilityName.length">
            Export
          </button>
        </div>
      </div>

      <div class="table-scroll" [ngClass]="{ 'scroll-expanded': expandedTable === 'name' }">
        <table>
          <thead>
            <tr>
              <th *ngFor="let col of columnsFacilityName">
                <div class="col-wrap">
                  <span>{{ col.header }}</span>
                  <div class="filter-icon-container" *ngIf="expandedTable === 'name' && col.filterable">
                    <img
                      class="filter-icon"
                      [ngClass]="{ 'active-filter': isFilterActive('name', col.field.toString()) }"
                      [src]="isFilterActive('name', col.field.toString()) ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                      width="16"
                      height="16"
                      alt="Filter"
                      [title]="isFilterActive('name', col.field.toString()) ? 'Filter applied - ' + col.header : 'Filter ' + col.header"
                      (click)="openFloatingFilter($event, 'name', col.field.toString())"
                    />
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of filteredDataFacilityName">
              <td *ngFor="let col of columnsFacilityName">
                <ng-container *ngIf="col.editable">
                  <input type="text" [ngModel]="getCellValue(row, col.field)" (ngModelChange)="
                      setCellValue(row, col.field, $event, 'name')
                    " [disabled]="!isEditable('name', row, col.field)" />
                </ng-container>
                <ng-container *ngIf="!col.editable">
                  {{ getCellValue(row, col.field) }}
                </ng-container>
              </td>
            </tr>
            <tr *ngIf="!filteredDataFacilityName.length">
              <td [attr.colspan]="columnsFacilityName.length" class="empty-filter-state">
                No facility names match the current filter.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div
    class="floating-filter-dropdown"
    #floatingFilterPanel
    *ngIf="showFloatingFilter && expandedTable === activeFilterTable"
    [ngStyle]="{
      top: dropdownPosition.top + 'px',
      left: dropdownPosition.left + 'px'
    }"
  >
    <input
      type="text"
      [ngModel]="getFilterSearchValue(activeFilterTable, activeFilter)"
      (ngModelChange)="setFilterSearchValue(activeFilterTable, activeFilter, $event)"
      placeholder="Search..."
    />

    <div class="filter-options">
      <div *ngIf="getFilterOptions(activeFilterTable, activeFilter).length === 0" class="no-options">
        No options available
      </div>
      <div class="filter-options-count" *ngIf="getFilterOptions(activeFilterTable, activeFilter).length > 0">
        {{ getFilterOptions(activeFilterTable, activeFilter).length }} options available
      </div>
      <label *ngFor="let option of getFilterOptions(activeFilterTable, activeFilter)">
        <input
          type="checkbox"
          [checked]="isChecked(activeFilterTable, activeFilter, option)"
          (change)="toggleMultiFilter(activeFilterTable, activeFilter, option, $event)"
        />
        <span>{{ option }}</span>
      </label>
    </div>

    <div class="filter-buttons">
      <button (click)="applyFilter(activeFilterTable)">Apply</button>
      <button (click)="clearFilter(activeFilterTable, activeFilter)">Clear</button>
    </div>
  </div>
</div>

<!-- Delete confirmation dialog template -->
<ng-template #deleteConfirmDialog>
  <div class="dialog-container">
    <h2 class="dialog-title">Confirm Delete</h2>
    <div class="dialog-content">
      <p>{{ dialogMessage }}</p>
    </div>
    <div class="dialog-actions">
      <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
      <button class="delete-button" [mat-dialog-close]="true">Delete</button>
    </div>
  </div>
</ng-template>